import type { Config, Locale } from '@schibsted-svp/web-player';

export const getLocale = (config: Config) => {
  return (config.locale ?? 'no') as Exclude<Locale, 'en'>;
};
